import { render, staticRenderFns } from "./add-delete-modal.vue?vue&type=template&id=4ec90908&scoped=true"
import script from "./add-delete-modal.vue?vue&type=script&lang=js"
export * from "./add-delete-modal.vue?vue&type=script&lang=js"
import style0 from "./add-delete-modal.vue?vue&type=style&index=0&id=4ec90908&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec90908",
  null
  
)

export default component.exports